import general from './general.json';
import alerts from './alerts.json';
import forms from './forms.json';
import toasts from './toasts.json';
import router_file from './router_file.json';
import modals from './modals.json';
import gotedo_table_definitions from './gotedo_table_definitions.json';
import onboarding_data_migration_module from './onboarding_data_migration_module.json';

export default {
  general,
  alerts,
  forms,
  toasts,
  modals,
  router_file,
  gotedo_table_definitions,
  onboarding_data_migration_module,
};
